module.exports = __webpack_public_path__ + "static/TrueFood_pin_hover-530c08c80ed6817790b444ed4e9fee65.png";